import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { cn } from '@/lib/utils';

const NAV = [
  { to: '/genres', key: 'nav.genres' },
  { to: '/styles', key: 'nav.styles' },
  { to: '/delegations', key: 'nav.agents' },
  { to: '/admin', key: 'nav.admin' },
];

/**
 * App identity + catalog navigation.
 *
 * This used to be re-rendered by each page's own header, which meant the app showed
 * two stacked headers and the nav disappeared once you opened a production.
 */
export default function BrandBar() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <div className="flex flex-shrink-0 items-center justify-between gap-3 px-7 py-3.5">
      <Link to="/projects" className="flex items-center gap-3">
        <img src="/logo-emblem.png" alt="" className="h-8 w-8 shrink-0 rounded-lg" />
        <span>
          <span className="block font-display text-[17px] font-semibold leading-tight">{t('app.name')}</span>
          <span className="block text-[11.5px] text-muted-foreground">{t('app.tagline')}</span>
        </span>
      </Link>

      <nav className="flex items-center gap-6 text-[12.5px]">
        {NAV.map((n) => (
          <Link
            key={n.to}
            to={n.to}
            className={cn(
              'transition-colors hover:text-foreground',
              pathname === n.to ? 'font-medium text-foreground' : 'text-muted-foreground',
            )}
          >
            {t(n.key)}
          </Link>
        ))}
      </nav>
    </div>
  );
}
